import { useState, useCallback } from 'react';
import type { SatelliteImageMetadata } from '@/features/types';
import type { PickingInfo } from '@deck.gl/core';
import type { Feature } from 'geojson';
import {
  satelliteImageGeomLayer,
  satelliteImageBboxLayer,
} from '@/views/map/layers/satelliteMetadataSubLayer';

export interface PickMultipleObjectsMethod {
  (options: { x: number; y: number; layerIds: string[] }): PickingInfo[];
}

export const useSatelliteImageMetadata = () => {
  const [satelliteImageMetadata, setSatelliteImageMetadata] =
    useState<SatelliteImageMetadata>();

  const pickAndSetSatelliteMetadata = useCallback(
    (
      coordinates: [number, number],
      satelliteMetadata: Feature[],
      pickMultipleObjects: PickMultipleObjectsMethod
    ): void => {
      let metadata: SatelliteImageMetadata | undefined;

      if (satelliteMetadata) {
        const satImageLayers: PickingInfo[] = pickMultipleObjects({
          x: coordinates[0],
          y: coordinates[1],
          layerIds: [satelliteImageGeomLayer, satelliteImageBboxLayer],
        });

        const satImageGeomLayerResult = satImageLayers.find(
          (layer) => layer.sourceLayer?.id === satelliteImageGeomLayer
        );
        const satImageBboxLayerResult = satImageLayers.find(
          (layer) => layer.sourceLayer?.id === satelliteImageBboxLayer
        );

        if (satImageGeomLayerResult) {
          metadata = {
            ...satImageGeomLayerResult.object.properties,
            showImageryDate: true,
          };
        } else if (satImageBboxLayerResult) {
          metadata = {
            ...satImageBboxLayerResult.object.properties,
            showImageryDate: false,
          };
        }
      }

      setSatelliteImageMetadata(metadata);
    },
    []
  );

  return {
    satelliteImageMetadata,
    pickAndSetSatelliteMetadata,
  };
};
